import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Inset below settings section titles (Theme, Dashboard, Resources, Language).
 * Keeps vertical and horizontal rhythm consistent with ThemeButton’s control row.
 */
export const settingsSectionBodyInsetSx: SxProps<Theme> = {
  pt: 1,
  px: 1,
};
